import axios, { AxiosError, AxiosRequestConfig } from "axios";

const setUpInterceptor = (store: any) => {
  axios.interceptors.request.use(async (config: any | AxiosRequestConfig) => {
    const authToken = store?.getState()?.auth?.token;
    const authConfig = authToken
      ? { Authorization: `Bearer ${authToken}` }
      : {};
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

    if (config.url !== "https://oauth2.googleapis.com/token") {
      config.headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...authConfig,
        user_timezone: timeZone,
        ...config.headers,
      };
    }

    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      if (error?.response?.status === 401) {
        store.dispatch({ type: "user/LOGOUT/fulfilled" }).finally(() => {
          window.location.href = "/";
        });
      }

      if (error?.response?.status === 502 || error?.message?.includes("502")) {
        console.error("Server error (502 Bad Gateway)", error);
        window.location.href = `${import.meta.env.BASE_URL}page502`;
      }

      return Promise.reject(error?.response?.data || error?.response || error);
    }
  );
};

export default setUpInterceptor;
